export default "/profile/images/screen2.png?dad0a610237aa0c500db032ab55b74d5";